import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import {
  HelperViewStatus,
  HeadingDisplay,
  Row,
  SkeletonLoader,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';
import { PaidEventsConfigurationModal } from './components/PaidEventsConfigurationModal';
import DetailModal from './components/DetailModal/DetailModal.vue';
import {
  PortfolioPaidEvent,
  PortfolioPaidEventConfiguration
} from '@/modules/wealth/services/portfolio';

interface Props {
  isLoading?: boolean;
  hasError?: boolean;
  paidEventsConfiguration?: PortfolioPaidEventConfiguration | null;
  paidEvents?: PortfolioPaidEvent[];
}
interface Emit {
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PaidEvents',
  props: {
    isLoading: { type: Boolean },
    hasError: { type: Boolean },
    paidEventsConfiguration: null,
    paidEvents: null
  },
  emits: ["on-retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isLoading?: boolean;
  hasError?: boolean;
  paidEventsConfiguration?: PortfolioPaidEventConfiguration | null;
  paidEvents?: PortfolioPaidEvent[];
}





const isConfigurationModalOpen = ref(false);
const isDetailModal = ref(false);
const detailModalPaidEvent = ref<PortfolioPaidEvent | undefined>(undefined);

const emitRetry = () => emit('on-retry');

const paidEventsDescription = computed(() => {
  return props.paidEventsConfiguration?.destination?.formatted;
});

const showConfigurationButton = computed(() => {
  return !!props.paidEventsConfiguration;
});

const toggleConfigurationModal = () => {
  isConfigurationModalOpen.value = !isConfigurationModalOpen.value;
};

const openDetailModal = (paidEvent: PortfolioPaidEvent) => {
  isDetailModal.value = true;
  detailModalPaidEvent.value = paidEvent;
};

const closeDetailModal = () => {
  isDetailModal.value = false;
};

return { __sfc: true,props, emit, isConfigurationModalOpen, isDetailModal, detailModalPaidEvent, emitRetry, paidEventsDescription, showConfigurationButton, toggleConfigurationModal, openDetailModal, closeDetailModal, HelperViewStatus, HeadingDisplay, Row, SkeletonLoader, InitialAvatarIcon, Money, PaidEventsConfigurationModal, DetailModal }
}

})